import { Button, Col, Form, Row } from "antd";
import { LOGIN_PATH } from "../env";
import "./Error.css";
import { ExclamationCircleFilled } from "@ant-design/icons";

const Error = () => {
  return (
    <>
      <Row className="bodyss">
        <Row className="Rower">
          <Row>
            <Col className="centerov" span={14}>
              <div>
                <h3 className="loginf">
                  <ExclamationCircleFilled className="iconEx" rev={undefined} />{" "}
                  ERROR 404
                </h3>
                <p className="loginf2">
                  Oh no, non troviamo la diagnosi giusta! <br /> Riprova a
                  cercare.
                </p>
              </div>
            </Col>
            <Col className="center0" span={4}></Col>
            <Col className="centero" span={6}>
              <Form.Item>
                <Button href={"app/" + LOGIN_PATH} className="login-boton">
                  Ritorna alla Home
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Row>
      </Row>
    </>
  );
};

export default Error;
